import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { GradientButton } from '../../../components/Button';

export const StyledBannerContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px;
  background-color: ${colorsPalettes.blue[100]};
  border-radius: 6px;
  margin-bottom: 12px;
  user-select: none;
`;

export const StyledTextContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const StyledTitle = styled.p`
  margin: 0;
  ${setFontVariant('listItem1', colorsPalettes.carbon[500])};
`;

export const StyledDescription = styled.p`
  margin: 2px 0 0;
  ${setFontVariant('tooltip', colorsPalettes.carbon[500])};
  opacity: 0.8;
`;

export const StyledTryAiOutreachButton = styled(GradientButton)`
  align-self: flex-start;
  padding: 6px 14px;
  border-radius: 18px;
  margin-top: 10px;
`;

export const StyledButtonText = styled.div`
  ${setFontVariant('button', colorsPalettes.carbon[0])}
`;
